import React from 'react'
import PropTypes from 'prop-types'
import BlockContent from '../shared/blockContent'

import './contactPageContent.css'

const ContactPageContent = ({ siteConfig }) => (
  <section className="contactPageContent">
    <div className="content">
      <div className="address">
        <h3>Find us</h3>
        {typeof siteConfig.offices[0].address === 'string' ? (
          <address>{siteConfig.offices[0].address}</address>
        ) : (
          <BlockContent input={siteConfig.offices[0].address}></BlockContent>
        )}
      </div>
      <div className="contact">
        <h3>Talk to us</h3>
        <a href={'mailto:' + siteConfig.email}>{siteConfig.email}</a>
        <a href={'tel:' + siteConfig.telephone.replace(/ /g, '')}>{siteConfig.telephone}</a>
        <h3>Complete us</h3>
        <a href={'mailto:' + siteConfig.recruitementEmail}>{siteConfig.recruitmentEmail}</a>
      </div>
      <div className="social">
        <h3>Follow us</h3>
        {siteConfig.social.map((service, index) => (
          <a href={service.url} key={`social-${index}`}>
            {service.name}
          </a>
        ))}
      </div>
    </div>
  </section>
)

ContactPageContent.propTypes = {
  siteConfig: PropTypes.object,
}

export default ContactPageContent
